import { Dispatch, SetStateAction, useCallback, useState } from "react";

export const useInput = <T>(initialState: T): [T, Dispatch<SetStateAction<T>>, (newValue: T) => void] => {
    const [value, setValue] = useState<T>(initialState);

    const handler = useCallback((newValue: any) => setValue(newValue), []); 

    return [value, setValue, handler];
};
